import { render, staticRenderFns } from "./SettingsCustomDomains.vue?vue&type=template&id=66c90f5b&"
import script from "./SettingsCustomDomains.vue?vue&type=script&lang=ts&"
export * from "./SettingsCustomDomains.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports